import { CLIENT_CONTRACT } from "./client_contract"

export const WEB_TRIP_POLICY = Object.freeze({
  nearbyJoinRadiusMi: CLIENT_CONTRACT.server.trip.joinRadius.defaultMi
})

export function formatJoinRadiusMiles(radiusMi = WEB_TRIP_POLICY.nearbyJoinRadiusMi) {
  const radius = Number(radiusMi)
  const label = Number.isInteger(radius) ? String(radius) : String(radius).replace(/0+$/, "").replace(/\.$/, "")
  return `${label} ${radius === 1 ? "mile" : "miles"}`
}
